// mutations
const resetPriceRange = state => {
  if (state.filters.priceMethod.value === 'per_person') {
    state.filters.priceRange.value.from = state.priceBoundaries.per_person[0];
    state.filters.priceRange.value.to = state.priceBoundaries.per_person[1];
    return;
  }

  state.filters.priceRange.value.from = state.priceBoundaries.default[0];
  state.filters.priceRange.value.to = state.priceBoundaries.default[1];
};

const mutations = {
  setRooms(state, rooms) {
    state.rooms = rooms;
  },
  setRoomsReducedFilters(state, rooms) {
    state.roomsReducedFilters = rooms;
  },
  setReducedFilters(state, filters) {
    state.reducedFilters = filters;
  },
  setNewBoundaries(state, boundaries) {
    state.boundaries = boundaries;
  },
  setLoading(state) {
    state.loading = true;
  },
  setLoaded(state) {
    state.loading = false;
  },
  setLoadingReducedFilters(state, value) {
    state.loadingReducedFilters = value;
  },
  setDisplayedRooms(state, value) {
    state.displayedRooms = value;
  },
  updateEventType(state, { key, value }) {
    state.eventTypeSlug = key;
    state.eventType = value;
  },
  setFromRoomTagSlug(state, value) {
    state.fromRoomTagSlug = value;
  },
  setCarriedQuickFilters(state, value) {
    state.carriedQuickFilters = value;
  },
  setLoadedEventType(state, value) {
    state.loadedEventType = value;
  },
  clearHighlightedRoom(state) {
    state.highlightedRoomData = null;
    state.highlightedRoomId = null;
  },
  updatePeople(state, value) {
    state.filters.people.value = value;
  },
  onDateChange(state, value) {
    state.filters.date.value = value;
  },
  setMetaHeader(state, metaHeader) {
    state.metaHeader = metaHeader;
  },
  setAdvancedFilter(state, { section, value }) {
    state.filters[section].value = value;
  },
  layoutChange(state, value) {
    state.filters.layout.value = value;
  },
  // @todo TM-261 updatePeople exist doing same
  peopleChange(state, value) {
    state.filters.people.value = value;
  },
  locationChange(state, { value, location }) {
    state.filters.location.value = value;
    state.boundaries = { ...location };
  },
  locationNameChange(state, value) {
    state.filters.location.value = value;
  },
  setTotalRooms(state, { totalRooms }) {
    state.totalRooms = totalRooms;
  },
  setQuickFilters(state, quickFilters) {
    state.quickFilters = quickFilters;
  },
  setTotalDisplayedRooms(state, value) {
    state.totalDisplayedRooms = value;
  },
  setPage(state, value) {
    state.page = value;
  },
  setPricingMethodCounter(state, value = {}) {
    state.metaPricingMethodCounter = value;
  },
  timeChange(state, times) {
    state.filters.timeFrom.value = times[0];
    state.filters.timeTo.value = times[1];
  },
  superVenuesOnlyChange(state, enabled) {
    state.filters.superVenuesOnly.value = enabled;
  },
  priceMethodChange(state, method) {
    state.filters.priceMethod.value = method;
  },
  flexibleCancellationChange(state, enabled) {
    state.filters.flexibleCancellation.value = enabled;
  },
  noAgeRestrictionChange(state, enabled) {
    state.filters.noAgeRestriction.value = enabled;
  },
  setVenueParts(state, ids) {
    state.filters.venueParts.value = ids;
  },
  setVenueTypes(state, ids) {
    state.filters.venueTypes.value = ids;
  },
  setAccessibilityFeature(state, { key, value }) {
    state.filters.accessibilityFeatures.value[key] = value;
  },
  clearAccessibilityFeatures(state) {
    state.filters.accessibilityFeatures.value = {};
  },
  priceChange(state, prices) {
    state.filters.priceRange.value.from = Math.max(prices[0], 0);
    state.filters.priceRange.value.to = prices[1];
  },
  resetPriceRange,
  // mobile
  showFilters(state) {
    state.mobileView = 'filters';
  },
  showResults(state) {
    state.mobileView = 'results';
  },
  showMap(state) {
    state.mobileView = 'map';
  },
  setMobileView(state, view) {
    if (['filters', 'results', 'map'].indexOf(view) === -1) {
      throw new Error(`Invalid mobile view. Got: ${view}`);
    }

    state.mobileView = view;
  },
  showAdvancedFilters(state) {
    state.showAdvancedFilters = true;
  },
  hideAdvancedFilters(state) {
    state.showAdvancedFilters = false;
  },
  removeFilter(state, filter) {
    if (Array.isArray(state.filters[filter].value)) {
      state.filters[filter].value = [];
    } else {
      state.filters[filter].value = null;
    }
  },
  setMobile(state, isMobile) {
    state.isMobile = isMobile;
  },
  resetFilters(state) {
    state.page = 1;
    state.filters.people.value = null;
    state.filters.layout.value = null;
    state.filters.date.value = null;

    state.filters.timeFrom.value = null;
    state.filters.timeTo.value = null;
    state.filters.catering.value = [];
    state.filters.roomFeatures.value = [];
    state.filters.allowedEvents.value = [];
    state.filters.venueFeatures.value = [];
    state.filters.superVenuesOnly.value = false;
    state.filters.flexibleCancellation.value = false;
    state.filters.noAgeRestriction.value = false;
    state.filters.location.value = state.initialLocation.neighbourhood;
    state.filters.priceMethod.value = null;
    state.filters.customPriceRange.value = null;
    state.filters.venueParts.value = [];
    state.filters.venueTypes.value = [];
    state.filters.accessibilityFeatures.value = {};
    state.filters.customRoomFeatures.value = [];
    state.filters.roomTags.value = [];

    resetPriceRange(state);
  },
  setHashId(state, id) {
    if (!id) {
      return;
    }

    state.hashId = id;
  },
  setTrackingCity(state, city) {
    if (!city) {
      return;
    }
    state.trackingCity = city;
  },
  setMapZoom(state, zoom) {
    state.mapZoom = zoom;
  },
  setDebugRoomsMap(state, roomIds) {
    state.debugFilterModeRooms = roomIds.reduce((acc, id) => {
      acc[id] = true;
      return acc;
    }, {});
  },
  enableDebugFilterMode(state) {
    state.perPage = state.debugFilterModeMaxRooms;
    state.debugFilterMode = true;
  },
  enableDebugShowMaxRooms(state) {
    state.perPage = state.debugFilterModeMaxRooms;
  },
  setEventCategory(state, val) {
    state.eventCategory = val;
  },
  setAdditionalRoomTags(state, tags) {
    state.additionalRoomTags = tags;
  },
  updateManagersLastActivityOnline(state, data) {
    state.managersLastActivityOnline = Object.keys(data).reduce((acc, venueId) => {
      acc[venueId] = data[venueId];
      return acc;
    }, state.managersLastActivityOnline);
  },
  setTrigger(state, trigger) {
    state.trigger = trigger;
  },
  setTriggerSection(state, triggerSection) {
    state.triggerSection = triggerSection;
  },
  setSelectedFiltersReactive(state, value) {
    state.selectedFiltersReactive = value;
  },
  setExperimentChipsFiltersWasMounted(state, value) {
    state.experimentChipsFiltersWasMounted = value;
  },
};

export default mutations;
